import styled from "styled-components"
import {H4} from "@irati/ui/src/Headings"

const StyledH4 = styled(H4)`
  margin: 40px 0 60px;
`

export default StyledH4

export const FormSectionHeading = styled(H4)`
  text-align: left;
  margin: 20px 0;
`
